import HelpIcon from '@mui/icons-material/Help';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Menu, Typography } from '@mui/material';
import { memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { HelpMenuItems } from './HelpMenuItems';

export const HelpMenu = memo(() => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const Icon = open ? HelpIcon : HelpOutlineIcon;

    const handleClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    }, []);

    const handleClose = useCallback(() => {
        setAnchorEl(null);
    }, []);

    return (
        <>
            <Box
                onClick={handleClick}
                data-testclass="nav-item-help"
                sx={{
                    display: 'flex',
                    gap: '12px',
                    alignItems: 'center',
                    position: 'relative',
                    height: '44px',
                    paddingLeft: '20px',
                    bgcolor: open ? 'primary.main' : 'transparent',
                    color: open ? 'common.white' : '#868686',
                    ':hover': !open
                        ? {
                              bgcolor: 'primary.100',
                              color: 'primary.main',
                              cursor: 'pointer',
                              '& .MuiSvgIcon-root': {
                                  color: 'primary.main',
                              },
                              '& .MuiTypography-root': {
                                  color: 'primary.main',
                              },
                          }
                        : {
                              cursor: 'pointer',
                          },
                }}
            >
                <Icon
                    sx={{
                        fontSize: '2rem',
                        color: open ? 'common.white' : '#868686',
                    }}
                />
                <Typography variant="subtitle2" sx={{ color: 'inherit' }}>
                    {t('Help')}
                </Typography>
            </Box>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 12px rgba(0, 0, 0, 0.1))',
                            minWidth: '200px',
                            borderRadius: '6px',
                            marginTop: '12px',
                        },
                    },
                }}
                sx={{
                    padding: 0,
                    margin: '-12px 0 0 2px',
                }}
                transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <HelpMenuItems />
            </Menu>
        </>
    );
});
